// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__fCikx","header":"MessagesList_header__3uZCX","chat":"MessagesList_chat__1Qt7E"};